import { authwsEnvironment } from '../authws-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { AuthHeaders } from '../../../models/auth-headers';
import { accountResponseSchema } from '../schemas/account.schema';
import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

const requestSchema = accountResponseSchema
  .omit({ id: true })
  .partial()
  .required({ name: true });

/**
 * Create a new account with the given name and fields (ALK Administrators only)
 * @param account Account info (name is required)
 * @returns Account Info
 */
export function postAccounts(
  this: unknown,
  account: z.infer<typeof requestSchema>
) {
  return fromFetch(
    new Request(authwsEnvironment.resolve(this).accountsUrl, {
      method: 'POST',
      headers: {
        ...requiredHeaders,
        ...new AuthHeaders(),
      },
      body: JSON.stringify(account),
    })
  ).pipe(selectData(accountResponseSchema));
}
